<div
  class="pu-form-container"
  [formGroup]="form()"
>
  <div
    class="pu-form-container"
    formGroupName="delivery"
  >
    @if (pickupLocations().length) {
      <pu-select
        formControlName="id"
        nameField="displayName"
        [label]="'deliveryForm.input.officeAddress*' | translate"
        [items]="pickupLocations()"
      />
    }
  </div>
</div>
